import styled from "@emotion/styled";
import { Typography, Button } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ModalTest from "../ModalTest";
import { helpHttp } from "../../helper/helpHttp";
import BackArrow from "../BackArrow";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { changeLoading } from "../../redux/slices/category";
import { BuildingPage } from "../BuildingPage/BuildingPage";
import { UnablePage } from "../UnablePage/UnablePage";
import Player from "@vimeo/player";

const Test = ({ isVentas = false }) => {
  const { get } = helpHttp();
  const [modulo, setModulo] = useState(undefined);
  const [aprobado, setAprobado] = useState(false);
  const [puedeReintentar, setPuedeReintentar] = useState(true);
  const [isLastItem, setIsLastItem] = useState(false);
  const [courseId, setCourseId] = useState(null);
  const dispatch = useDispatch();
  const [endedVideo, setEndedVideo] = useState(false);
  const iframeRef = useRef(null);
  const playerRef = useRef(null);
  const [videoIsPlaying, setVideoIsPlaying] = useState(false);

  const getModuleDetail = (moduleId) => {
    dispatch(changeLoading(true));
    get(`modulos/getModuloById/${moduleId}`)
      .then((data) => {
        setModulo(data.datos[0]);
        setAprobado(data.datos[0].aprobado === "1");
        setPuedeReintentar(data.datos[0].intentar === 1);
      })
      .catch(() => toast.error("Ha ocurrido un error"))
      .finally(() => {
        dispatch(changeLoading(false));
      });
  };

  const handleFullscreen = async () => {
    if (playerRef.current) {
      try {
        await playerRef.current.requestFullscreen();
      } catch (error) {
        console.error(
          "Error al reproducir o activar pantalla completa:",
          error.name
        );
      }
    }
  };

  useEffect(() => {
    if (modulo) {
      dispatch(changeLoading(true));
      get(`modulos/getModulosByCategoria/${courseId}`)
        .then((data) => {
          const ids = data.datos.map(({ id }) => Number(id));
          if (Number(modulo.id) === Math.max(...ids)) {
            setIsLastItem(true);
          }
        })
        .catch((error) => {
          toast.error("Ha ocurrido un error");
        })
        .finally(() => {
          dispatch(changeLoading(false));
        });
    }
  }, [modulo]);

  useEffect(() => {
    const url = window.location.href;
    const moduleId = url.split("/").at(-1);
    const courseId = url.split("/").at(-2);

    if (moduleId && courseId) {
      getModuleDetail(moduleId);
      setCourseId(courseId);
    }
  }, []);

  useEffect(() => {
    if (modulo?.url_video) {
      playerRef.current = new Player(iframeRef.current);

      playerRef.current.on("play", () => {
        setVideoIsPlaying(true);
      });

      playerRef.current.on("ended", () => {
        setEndedVideo(true);
        setVideoIsPlaying(false);
      });

      return () => {
        playerRef.current.off("ended");
        playerRef.current.off("play");
      };
    }
  }, [modulo]);

  const handleRequestCertificate = () => {
    get(`usuarios/getCertificateByUsuario/${courseId}`)
      .then((response) => {
        if (response.codigo === "200") {
          toast.success(
            "Se ha solicitado su certificado. El administrador estará revisando su solicitud"
          );
        } else {
          toast.error(response.mensaje);
        }
      })
      .catch((error) => {
        toast.error(error.mensaje);
      });
  };

  const renderButton = () => {
    if (!puedeReintentar) {
      return (
        <Typography className="aprobado" variant="title">
          Se ha superado el número de intentos máximos para la evaluación.
        </Typography>
      );
    }

    if (!aprobado) {
      return (
        <ModalTest
          modulo={modulo}
          getModuleDetail={getModuleDetail}
          disabled={!endedVideo}
          isVentas={isVentas}
        />
      );
    }

    return (
      <Typography className="aprobado" variant="title">
        Ya has aprobado este módulo.
      </Typography>
    );
  };

  return (
    <StyledArticle>
      <BackArrow />
      <main>
        <Typography
          variant="subtitle1"
          sx={{ textAlign: "center" }}
          fontSize={"1.3rem"}
        >
          Mira el video completo, haz clic en el botón <b>hacer evaluación</b> y
          responde correctamente para avanzar.
        </Typography>
        <header>
          <Typography variant="title" component="h2">
            {modulo?.nombre}
          </Typography>
          {renderButton()}
        </header>
        <StyledVideo>
          <iframe
            ref={iframeRef}
            frameBorder="none"
            width="100%"
            height="100%"
            src={modulo?.url_video}
            allow="fullscreen"
            loading="lazy"
            allowFullScreen
          />
        </StyledVideo>
        <Button disabled={!videoIsPlaying} onClick={handleFullscreen}>
          Pantalla completa
        </Button>
        <StyledFooter>
          {aprobado && isLastItem && (
            <Button
              color="secondary"
              onClick={handleRequestCertificate}
              variant="contained"
            >
              Solicitar certificado
            </Button>
          )}
        </StyledFooter>
      </main>
    </StyledArticle>
  );
};

const StyledFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;
const StyledArticle = styled.article`
  display: flex;
  gap: 10px;
  flex-direction: column;
  border-radius: 30px;
  background-color: #f7f7f7;
  padding: 10px;
  @media (min-width: 768px) {
    padding: 30px;
  }
  > main {
    padding: 10px;
    @media (min-width: 768px) {
      padding: 50px;
    }
    border-radius: 20px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .aprobado {
    font-size: 20px;
  }

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;
const StyledVideo = styled.div`
  width: 100%;
  aspect-ratio: 16/9;
  /* max-height: 400px; */
`;

export default Test;
